import { render, staticRenderFns } from "./EditDiversityDialog.vue?vue&type=template&id=23e99efe&"
import script from "./EditDiversityDialog.vue?vue&type=script&lang=js&"
export * from "./EditDiversityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports